// Classes.
import {ExtendedEventBaseItem} from '../types/extended-event-base.item';

// Services.
import {WaHelperService} from '../../wa-services/wa-helper-service';
import {FactoryService} from '../../wa-services/factory-service';


export class AthleteResultItem extends ExtendedEventBaseItem {

  public rank: number;
  /// @TODO: What is this value?
  public cont: number;
  public catCode: string;
  public isTeam: boolean;

  constructor(rawAthleteResultlInfoItem: any,
    protected _helper: WaHelperService,
    protected factory: FactoryService) {

    super(rawAthleteResultlInfoItem, _helper);

    // Process proprerties only in AthleteResultInfoItem.
    this.rank = rawAthleteResultlInfoItem.Rnk;
    this.catCode = rawAthleteResultlInfoItem.Cat;
    this.isTeam = rawAthleteResultlInfoItem.IsTeam;
  }

  get catCodeLabel(): string {
    let label = this.catCode;
    let catInfo = this._helper.getCategoryInfoByCode(this.catCode);

    if (!catInfo.isMixed && this.isTeam) {
      label += 'T';
    }

    return label;
  }

}
